import { render, staticRenderFns } from "./Jingles.vue?vue&type=template&id=55dfd124&scoped=true&"
import script from "./Jingles.vue?vue&type=script&lang=js&"
export * from "./Jingles.vue?vue&type=script&lang=js&"
import style0 from "./Jingles.vue?vue&type=style&index=0&id=55dfd124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dfd124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VContainer,VVirtualScroll})
